<div class="edit-client-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header">
    <h2 mat-dialog-title>
      <mat-icon class="header-icon">edit</mat-icon>
      Edit Client
    </h2>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Loading Overlay -->
  <div class="loading-overlay" *ngIf="loadingClient">
    <mat-spinner diameter="40"></mat-spinner>
    <p>Loading client data...</p>
  </div>

  <!-- Dialog Content -->
  <div class="dialog-content" *ngIf="!loadingClient">
    <form [formGroup]="clientForm" class="edit-client-form">
      <!-- Client Name Section -->
      <div class="form-section">
        <h3 class="section-title">Client Information</h3>
        <div class="form-row">
          <div>
            <mat-label>First Name *</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <input
                matInput
                formControlName="client_first_name"
                placeholder="Enter first name"
              />
              <mat-error
                *ngIf="clientFirstName?.errors?.['required'] && clientFirstName?.touched"
              >
                First name is required
              </mat-error>
              <mat-error
                *ngIf="clientFirstName?.errors?.['minlength'] && clientFirstName?.touched"
              >
                First name must be at least 2 characters
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-label>Last Name *</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <input
                matInput
                formControlName="client_last_name"
                placeholder="Enter last name"
              />
              <mat-error
                *ngIf="clientLastName?.errors?.['required'] && clientLastName?.touched"
              >
                Last name is required
              </mat-error>
              <mat-error
                *ngIf="clientLastName?.errors?.['minlength'] && clientLastName?.touched"
              >
                Last name must be at least 2 characters
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-row">
          <div>
            <mat-label>Client Type *</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <mat-select formControlName="type">
                <mat-option
                  *ngFor="let type of clientTypes"
                  [value]="type.value"
                >
                  {{ type.label }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="type?.errors?.['required'] && type?.touched">
                Client type is required
              </mat-error>
            </mat-form-field>
          </div>
          <div>
            <mat-label>Contact Number *</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <input
                matInput
                formControlName="contact_number"
                placeholder="Enter phone number"
              />
              <mat-icon matSuffix>phone</mat-icon>
              <mat-error
                *ngIf="contactNumber?.errors?.['required'] && contactNumber?.touched"
              >
                Contact number is required
              </mat-error>
              <mat-error
                *ngIf="contactNumber?.errors?.['pattern'] && contactNumber?.touched"
              >
                Invalid phone number format
              </mat-error>
              <mat-error *ngIf="contactNumber?.errors?.['duplicate']">
                A client with this contact number already exists
              </mat-error>
            </mat-form-field>
          </div>

          <!-- <mat-form-field appearance="outline" class="form-field">
            <mat-label>Contact Person *</mat-label>
            <input matInput formControlName="contact_person" placeholder="Enter contact person name">
            <mat-error *ngIf="contactPerson?.errors?.['required'] && contactPerson?.touched">
              Contact person is required
            </mat-error>
            <mat-error *ngIf="contactPerson?.errors?.['minlength'] && contactPerson?.touched">
              Contact person must be at least 2 characters
            </mat-error>
          </mat-form-field> -->
        </div>

        <div class="form-row">
          <div>
            <mat-label> {{"line1"| translate }}</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <textarea
                matInput
                formControlName="line_1"
                placeholder="Enter line 1 address"
                rows="2"
              ></textarea>
              <mat-icon matSuffix>location_on</mat-icon>
              <mat-error
                *ngIf="line_1?.errors?.['required'] && line_1?.touched"
              >
                Address is required
              </mat-error>
            </mat-form-field>
          </div>
          <div>
          
            <mat-label> {{"line2"| translate }}</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <textarea
                matInput
                formControlName="line_2"
                placeholder="Enter line 2 address"
                rows="2"
              ></textarea>
              <mat-icon matSuffix>location_on</mat-icon>
              <mat-error
                *ngIf="line_2?.errors?.['required'] && line_2?.touched"
              >
                Address is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Location Section -->
      <div class="form-section">
        <h3 class="section-title">Location Information</h3>
        <div class="form-row">
          <div>
            <mat-label>State *</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <mat-select formControlName="state" placeholder="Select state" (selectionChange)="getdistricts()">
                <mat-option *ngFor="let state of allState" [value]="state">
                  {{ state }}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix>map</mat-icon>
              <mat-error *ngIf="state?.errors?.['required'] && state?.touched">
                State is required
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-label>District *</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <mat-select
                formControlName="district"
                placeholder="Select district"
                [disabled]="!allDistricts.length"
                (selectionChange)="getsubdistricts()"
              >
                <mat-option
                  *ngFor="let district of allDistricts"
                  [value]="district"
                >
                  {{ district }}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix>location_city</mat-icon>
              <mat-error
                *ngIf="district?.errors?.['required'] && district?.touched"
              >
                District is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="form-row">
          <div>
            <mat-label>Sub-District *</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <mat-select
                formControlName="sub_district"
                placeholder="Select sub-district"
                [disabled]="!allSubDistricts.length"
                (selectionChange)="getvillages()"
              >
                <mat-option
                  *ngFor="let subDistrict of allSubDistricts"
                  [value]="subDistrict"
                >
                  {{ subDistrict }}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix>location_city</mat-icon>
              <mat-error
                *ngIf="subDistrict?.errors?.['required'] && subDistrict?.touched"
              >
                Sub-district is required
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <mat-label>Village *</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <mat-select
                formControlName="villages"
                placeholder="Select village"
                [disabled]="!allVillage.length"
              >
                <mat-option
                  *ngFor="let village of allVillage"
                  [value]="village"
                >
                  {{ village }}
                </mat-option>
              </mat-select>
              <mat-icon matSuffix>home</mat-icon>
              <mat-error
                *ngIf="villages?.errors?.['required'] && villages?.touched"
              >
                Village is required
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Additional Information Section -->
      <div class="form-section">
        <h3 class="section-title">Additional Information</h3>
        <div class="form-row">
          <div>
            <mat-label>Khasra Number</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <input
                matInput
                formControlName="khasra_no"
                placeholder="Enter khasra number"
              />
              <mat-icon matSuffix>description</mat-icon>
            </mat-form-field>
          </div>

          <div>
            <mat-label>Area</mat-label>

            <mat-form-field appearance="outline" class="form-field">
              <input matInput formControlName="area" placeholder="Enter area" />
              <mat-icon matSuffix>straighten</mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- Form Actions -->
      <div class="form-actions">
        <button
          type="button"
          mat-button
          (click)="onCancel()"
          [disabled]="loading"
          class="cancel-button"
        >
          Cancel
        </button>
        <button
          type="submit"
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          [disabled]="clientForm.invalid || loading"
          class="submit-button"
        >
          <mat-spinner diameter="20" *ngIf="loading"></mat-spinner>
          <span *ngIf="!loading">Update Client</span>
          <span *ngIf="loading">Updating...</span>
        </button>
      </div>
    </form>
  </div>
</div>
